import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ProtectedRoute, RoleRoute, PermissionRoute } from './routes/ProtectedRoute';
import LoginPage from './pages/Auth/Login';
import Layout from './components/layout/Layout';
import AdminDashboard from './pages/AdminDashboard';
import UserDetail from './pages/UserDetail';
import BetHistoryDashboard from './pages/BetHistoryDashboard';
import PaymentMethods from './pages/PaymentMethods';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Wallet from './pages/WalletUpdate';
import AdminAccount from './pages/AdminAccount';
import ManualWithdrawal from './pages/ManualWithdrawal';
import ManualDeposit from './pages/ManualDeposit';
import Level from './pages/Level';
import DepositBonus from './pages/DepositBonus';
import DepositCommissionLevel from './pages/LevelCommission/DepositCommissionLevel';
import Agent from './pages/Agent';
import Wingo from './pages/Wingo';
import PendingIssues from './pages/Support/PendingIssues';
import ResolvedIssues from './pages/Support/ResolvedIssues';
import GiftCode from './pages/GiftCode';
import CollaboratorsProfile from './pages/CollaboratorsProfile';
import BetCommissionLevel from './pages/LevelCommission/BetCommissionLevel';
import Analytics from './pages/Analytics/Analytics';
import BonusAndPaneltyHistory from './pages/BonusAndPaneltyHistory';
import BonusAndPanelty from './pages/BonusAndPanelty';
import Milestones from './pages/Milestones';
import BetHistoryDashboardNew from './pages/BetHistoryDashboardNew';
import GiftUsedUser from './pages/GiftUsedUser';

// RBAC Pages
import AdminsManagement from './pages/RBAC/AdminsManagement';
import BackOfficeManagement from './pages/RBAC/BackOfficeManagement';
import RolePermissions from './pages/RBAC/RolePermissions';
import AuditLogs from './pages/RBAC/AuditLogs';
import AgentDashboard from './pages/AgentDashboard';

function App() {
  return (
    <Routes>
      {/* Public Auth */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Layout */}
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route index element={<AdminDashboard />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/users" element={<Users />} />
                <Route path="/users/profile/:id" element={<UserDetail />} />
                <Route path="/api-management" element={<BetHistoryDashboard />} />
                <Route path="/api-management-new" element={<BetHistoryDashboardNew />} />
                <Route path="/settings/general" element={<Settings />} />
                <Route path="/settings/payments" element={<PaymentMethods />} />
                <Route path="/bonus-and-panelty" element={<BonusAndPanelty />} />
                <Route path="/bonus-and-panelty-history" element={<BonusAndPaneltyHistory />} />
                <Route path="/admin" element={<AdminAccount />} />

                <Route path="/recharge-list" element={<ManualDeposit />} />
                <Route path="/approved-recharges" element={<ManualDeposit />} />

                <Route path="/withdrawal-list" element={<ManualWithdrawal />} />
                <Route path="/approved-withdrawals" element={<ManualWithdrawal />} />

                <Route path="/settings/deposit/bonus" element={<DepositBonus />} />

                {/* Agents & Stores (Backward compatible + Agent Portal) */}
                <Route path="/agent" element={<Agent />} />
                <Route path="/collaborators/profile" element={<CollaboratorsProfile />} />
                <Route path="/collaborators/profile/:id" element={<CollaboratorsProfile />} />
                <Route
                  path="/agent/dashboard"
                  element={
                    <RoleRoute roles={["SUPER_ADMIN", "ADMIN", "AGENT"]}>
                      <AgentDashboard />
                    </RoleRoute>
                  }
                />

                {/* RBAC Architecture Routes */}
                <Route
                  path="/rbac/admins"
                  element={
                    <RoleRoute roles={["SUPER_ADMIN"]}>
                      <AdminsManagement />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/rbac/back-office"
                  element={
                    <RoleRoute roles={["SUPER_ADMIN", "ADMIN"]}>
                      <BackOfficeManagement />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/rbac/roles"
                  element={
                    <RoleRoute roles={["SUPER_ADMIN"]}>
                      <RolePermissions />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/rbac/audit-logs"
                  element={
                    <RoleRoute roles={["SUPER_ADMIN", "ADMIN"]}>
                      <AuditLogs />
                    </RoleRoute>
                  }
                />

                <Route path="/wingo-management" element={<Wingo />} />

                {/* Support */}
                <Route path="/pending-issues" element={<PendingIssues />} />
                <Route path="/resolved-issues" element={<ResolvedIssues />} />

                <Route path="/gift-codes" element={<GiftCode />} />
                <Route path="/gift-used-user" element={<GiftUsedUser />} />
                <Route path="/milestones" element={<Milestones />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
